export const segmentProps = {
  device: "device",
  web: "Web",
  welcomeEmail: "welcome email",
  firstLoginTrack: "first login track",
  email: "email",
  phone: "phone",
  userName: "userName",
  vehicleId: "vehicleId",
  driverName: "driverName",
  vin: "vin",
  year: "year",
  make: "make",
  model: "model",
  lastServiceDate: "lastServiceDate",
  driverId: "driverId",
  address: "address",
  city: "city",
  state: "state",
  zip: "zip",
  source: "from where",
  driverNameKey: "driver name",
  driverEmail: "driver email",
  driverCellPhone: "driver cell phone",
  driverCountry: "driver country",
  driverFleetId: "driver fleet id",
};
